/* eslint-disable indent */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useState, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
  Text,
  Space,
  Conditional,
  Toggle,
  Dropdown,
  InputWithAction,
  InputField,
  DropdownMenu,
  DropdownItem,
  Popup,
} from '@cashfree-intl/coherent';

import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';
import Loader from 'components/Loader';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { StyledDropdown } from 'containers/Vendors/styled';

import { MerchantContext } from '../../../../../contexts/MerchantContext';
import {
  BANK_DETAILS,
  DELETE_BANK_DETAILS,
  IN_BENE_CREATION,
  VENDOR_BUSINESS_TYPE_INFO_LINK,
  VENDOR_BUSINESS_TYPE_OPTIONS,
  VENDOR_DASHBOARD_INFO_LINK,
  VENDOR_LINE_OF_BUSINESS_OPTIONS,
  VENDOR_LOB_INFO_LINK,
  VENDOR_SETTLEMENT_CYCLE_INFO_LINK,
} from '../../../constants';
import vendorDetailsFormvalidationSchema from './Validations/VendorDetailsFormValidation';

export function VendorDetailsForm({
  open,
  isEditMode,
  data = {},
  scheduleOptions = {},
  editModalLoading,
  step,
  setStep,
  handleVendorDetailsPayload,
  vendorFormData,
  setVendorFormData,
  vendorStatus,
  vpaEnabled,
  active,
  setActive,
  isKycDataFilled,
  detailsPageClicked,
  passVendorDetails,
  incrementalVendorOnboarding,
  submitVendorDetails,
  vendorCreated,
  vendorDocs,
}) {
  const [toggleChanged, setToggleChanged] = useState(true);
  const [accountType, setAccountType] = useState('');
  const [otherBusinessType, setOtherBusinessType] = useState(false);
  const [tempValues, setTempValues] = useLocalStorage('vendorFormData');

  const tempValuesRef = useRef({});

  const onToggle = () => {
    setToggleChanged(false);
    setActive(prev => !prev);
  };

  const { vendorDashboardEnabled = false } = useContext(MerchantContext);

  const showVendorDbToggle = vendorDashboardEnabled;

  let initialValues = incrementalVendorOnboarding
    ? {
        email: '',
        vendorId: '',
        phone: '',
        numberInitial: '+91',
        accountNumber: '',
        ifsc: '',
        vpa: '',
        scheduleOption: '',
        name: '',
        verifyAccount: false,
        businessType: '',
        accountType: '',
        ...tempValues,
      }
    : {
        email: '',
        vendorId: '',
        phone: '',
        numberInitial: '+91',
        accountNumber: '',
        ifsc: '',
        vpa: '',
        scheduleOption: '',
        name: '',
        verifyAccount: false,
        ...tempValues,
      };

  useEffect(() => {
    tempValuesRef.current = { ...tempValues };
  }, [tempValues]);

  useEffect(() => {
    const accType = data?.accountType || vendorFormData?.accountType;
    if (accType) {
      const vendorAccType = VENDOR_BUSINESS_TYPE_OPTIONS.find(
        item => item.text === accType,
      );
      setAccountType(vendorAccType);
    }
  }, [data, vendorFormData]);

  useEffect(() => {
    if (Object.keys(data).length) {
      if (toggleChanged && !isKycDataFilled) {
        setActive(data.dashboardAccess || false);
      }
    }

    // account type is not needed when - incrementalVendorOnboarding is true
    // therefore removing the previous code
    if (vendorFormData)
      initialValues = { ...vendorFormData, ...tempValuesRef.current };
  }, [data, vendorFormData, tempValuesRef.current]);

  if (Object.keys(data).length !== 0) {
    initialValues = data;
    // account type is not needed when - incrementalVendorOnboarding is true
    // therefore removing the previous code
    if (incrementalVendorOnboarding && otherBusinessType && isEditMode) {
      initialValues = {
        ...initialValues,
        businessTypeInfo: data?.businessType,
        businessType: 'Other',
      };
    }
  }

  if (showVendorDbToggle && step === 1) {
    initialValues = {
      ...initialValues,
      dashboardAccess: active,
    };
  }

  const SettlementCycleOptions = Object.keys(scheduleOptions).map(key => ({
    key,
    value: key,
    text: scheduleOptions[key],
  }));

  const onNextClickHandler = values => {
    const vendorPayload = { ...values };
    setVendorFormData({ ...values });
    setStep(step + 1);
    if (step === 2) {
      Object.keys(vendorPayload).forEach(key => {
        if (vendorPayload[key] && typeof vendorPayload[key] === 'string')
          vendorPayload[key] = vendorPayload[key].trim();
      });
      const updatedPayload = {
        ...vendorPayload,
        phone: `${vendorPayload.numberInitial}${vendorPayload.phone}`,
        accountHolder: vendorPayload.name,
      };
      delete updatedPayload.numberInitial;
      if (showVendorDbToggle) {
        updatedPayload.dashboardAccess = active;
      }
      passVendorDetails(updatedPayload);
    }
  };

  const submitForm = (values, actions) => {
    const vendorPayload = { ...values, ...tempValuesRef.current };
    setVendorFormData({ ...values, ...tempValuesRef.current });
    if (step === 1 && !detailsPageClicked) {
      setStep(step + 1);
      actions.setSubmitting(false);
    } else if (step === 2 || detailsPageClicked) {
      Object.keys(vendorPayload).forEach(key => {
        if (vendorPayload[key] && typeof vendorPayload[key] === 'string')
          vendorPayload[key] = vendorPayload[key].trim();
      });

      let updatedPayload = {
        ...vendorPayload,
        phone: `${vendorPayload.numberInitial}${vendorPayload.phone}`,
        accountHolder: vendorPayload.name,
      };
      delete updatedPayload.numberInitial;
      if (showVendorDbToggle) {
        updatedPayload.dashboardAccess = active;
      }

      if (detailsPageClicked) {
        if (
          data?.accountType === updatedPayload?.accountType &&
          data?.businessType === updatedPayload?.businessType
        ) {
          delete updatedPayload?.businessType;
          delete updatedPayload?.accountType;
        }
      }

      if (
        updatedPayload?.businessType === 'Other' &&
        updatedPayload?.businessTypeInfo
      ) {
        updatedPayload = {
          ...updatedPayload,
          businessType: updatedPayload.businessTypeInfo,
        };
        delete updatedPayload.businessTypeInfo;
      }
      if (isEditMode) {
        let deleteBankDetails = true;
        BANK_DETAILS.forEach(property => {
          if (data[property] !== values[property]) {
            deleteBankDetails = false;
          }
        });

        if (deleteBankDetails) {
          DELETE_BANK_DETAILS.forEach(property => {
            delete updatedPayload[property];
          });
        }
      }
      // remove accountType if incrementalVendorOnboarding
      if (incrementalVendorOnboarding) delete updatedPayload.accountType;

      if (!detailsPageClicked && incrementalVendorOnboarding) {
        const incrementStep = () => {
          setStep(step + 1);
        };
        submitVendorDetails(
          updatedPayload,
          actions,
          incrementStep,
          vendorCreated,
        );
      }
      if (detailsPageClicked)
        handleVendorDetailsPayload(updatedPayload, actions);
      else if (!detailsPageClicked && !incrementalVendorOnboarding) {
        setStep(step + 1);
        handleVendorDetailsPayload(updatedPayload);
      }
    }
  };

  const updateValuesToLS = () => {
    setTempValues(tempValuesRef.current);
  };

  const onCancelHandler = (e, values) => {
    tempValuesRef.current = { ...values, ...tempValuesRef.current };
    updateValuesToLS();
    setStep(0);
  };

  const onClickCrossHandler = () => {
    updateValuesToLS();
    setStep(0);
  };

  return (
    <Modal
      open={open}
      className="common-modal-wrapper add-vendorV2-wrapper"
      $maxWidth={incrementalVendorOnboarding ? '520' : '480'}
    >
      <ModalHeader>
        <div>
          <div className="heading">
            {`${isEditMode ? 'Edit' : 'Add '} Vendor`}
          </div>
        </div>
        <div
          className="close-modal"
          onClick={onClickCrossHandler}
          data-event-name="Form_VendorDetailsForm_Icon_Close"
          data-ignore-inner-text="true"
          data-event-properties={JSON.stringify({ step })}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content loading-modal">
          <Loader active={editModalLoading} isModal paragraph={2} />
          {!editModalLoading && (
            <FormikComponent
              initialValues={initialValues}
              validationSchema={vendorDetailsFormvalidationSchema(
                step,
                incrementalVendorOnboarding,
              )}
              onSubmit={submitForm}
            >
              {({
                values = {},
                handleFieldBlur,
                handleFieldChange: onHandleFieldChange,
                handleSubmit,
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
                ...formikProps
              }) => {
                const handleFieldChange = (e, data) => {
                  onHandleFieldChange(e, data);
                  tempValuesRef.current = {
                    ...values,
                    ...tempValuesRef.current,
                    [data.name]: data?.value,
                  };
                };

                const disableField =
                  !formikProps.isValidating && formikProps.isSubmitting;
                const errStep =
                  errors.vendorId ||
                  errors.email ||
                  errors.phone ||
                  errors.scheduleOption ||
                  errors.accountNumber ||
                  errors.ifsc ||
                  errors.name;
                const handleKeyPress = e => {
                  if (errStep || disableField || !values.vendorId) return;
                  if (e.charCode === 13) {
                    setStep(step + 1);
                  }
                };
                const showPhoneError = !!errors.phone && !!touched.phone;
                if (isEditMode && (!touched.accountNumber || !touched.ifsc)) {
                  setFieldTouched('accountNumber', true);
                  setFieldTouched('ifsc', true);
                }
                const handleBusinessDropdownChange = option => {
                  setAccountType(option);
                  setFieldValue('accountType', option?.value);
                };
                const handleVendorLOBChange = (e, data) => {
                  setOtherBusinessType(false);
                  handleFieldChange(e, data);
                };
                return (
                  <form autoComplete="off" onSubmit={handleSubmit}>
                    {step === 1 && (
                      <>
                        <Space justifyContent="space-between">
                          <Text variant="h16" strong className="mb-4">
                            Vendor Details
                          </Text>
                          <span className="step">
                            Step {step}/{isKycDataFilled ? 3 : 2}
                          </span>
                        </Space>
                        <InputField
                          fluid
                          id="vendorId"
                          name="vendorId"
                          label="Vendor ID"
                          value={values.vendorId}
                          errors={errors}
                          touched={touched}
                          onChange={(e, data) => {
                            const pattern = /^[a-zA-Z0-9_]*$/;
                            if (
                              !pattern.test(e.target.value) &&
                              e.target.value
                            ) {
                              return;
                            }
                            handleFieldChange(e, data);
                          }}
                          onBlur={handleFieldBlur}
                          disabled={isEditMode || disableField || vendorCreated}
                          onKeyPress={handleKeyPress}
                          placeholder="Enter vendor ID"
                        />
                        <div>
                          <Text
                            variant="b14"
                            color="bodyLight"
                            className="mb-1 mt-3"
                          >
                            Phone Number
                          </Text>
                          <InputWithAction
                            fluid
                            id="phone"
                            name="phone"
                            className={`input-field-with-text-label ${
                              showPhoneError ? 'error_border' : ''
                            }`}
                            label={{
                              basic: true,
                              content: values.numberInitial,
                            }}
                            value={values.phone}
                            onBlur={handleFieldBlur}
                            onChange={(e, data) => {
                              const pattern = /^[0-9]{0,10}$/;
                              if (
                                !pattern.test(e.target.value) &&
                                e.target.value
                              ) {
                                return;
                              }
                              handleFieldChange(e, data);
                            }}
                            disabled={disableField}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter Phone Number"
                          />
                          {showPhoneError && (
                            <div className="error-message mt-4">
                              {errors.phone}
                            </div>
                          )}
                        </div>

                        <InputField
                          fluid
                          id="email"
                          name="email"
                          label="Email ID"
                          className={`${showPhoneError ? '' : 'mt-4'}`}
                          value={values.email}
                          errors={errors}
                          touched={touched}
                          onChange={handleFieldChange}
                          onBlur={handleFieldBlur}
                          disabled={disableField}
                          onKeyPress={handleKeyPress}
                          placeholder="Enter Email"
                        />
                        <Conditional if={incrementalVendorOnboarding}>
                          <div className="select-with-custom-icon">
                            <Space
                              className="mb-1 mt-3"
                              gap={1}
                              alignItems="center"
                            >
                              <Text variant="b14" color="bodyLight">
                                Vendor Line Of Business
                              </Text>
                              <Popup
                                content={
                                  <Text variant="b12">
                                    <a
                                      href={VENDOR_LOB_INFO_LINK}
                                      target="_blank"
                                    >
                                      Click here
                                    </a>{' '}
                                    to know more
                                  </Text>
                                }
                                trigger={
                                  <div className="pointer">
                                    <CustomIcon componentName="INFO" />
                                  </div>
                                }
                                position="top center"
                                hoverable
                              />
                            </Space>
                            <StyledDropdown>
                              <Dropdown
                                fluid
                                name="businessType"
                                label="Vendor Line Of Business"
                                value={values.businessType}
                                placeholder=""
                                options={VENDOR_LINE_OF_BUSINESS_OPTIONS}
                                errors={errors}
                                touched={touched}
                                onBlur={handleFieldBlur}
                                onChange={(e, data) =>
                                  handleVendorLOBChange(e, data)
                                }
                                disabled={disableField}
                                selection
                                icon="chevron down"
                              />
                            </StyledDropdown>
                          </div>
                          <Conditional
                            if={
                              otherBusinessType && incrementalVendorOnboarding
                            }
                          >
                            <InputField
                              fluid
                              id="businessTypeInfo"
                              name="businessTypeInfo"
                              // className={`${showPhoneError ? '' : 'mt-4'}`}
                              value={values.businessTypeInfo}
                              errors={errors}
                              touched={touched}
                              onChange={handleFieldChange}
                              onBlur={handleFieldBlur}
                              disabled={disableField}
                              onKeyPress={handleKeyPress}
                              placeholder="Enter whatever best describes your Business"
                            />
                          </Conditional>
                          <Conditional if={!incrementalVendorOnboarding}>
                            <Space
                              className="mb-1 mt-3"
                              gap={1}
                              alignItems="center"
                            >
                              <Text variant="b14" color="bodyLight">
                                Vendor Business Type
                              </Text>
                              <Popup
                                content={
                                  <Text variant="b12">
                                    <a
                                      href={VENDOR_BUSINESS_TYPE_INFO_LINK}
                                      target="_blank"
                                    >
                                      Click here
                                    </a>{' '}
                                    to know more
                                  </Text>
                                }
                                trigger={
                                  <div className="pointer">
                                    <CustomIcon componentName="INFO" />
                                  </div>
                                }
                                position="top center"
                                hoverable
                              />
                            </Space>
                            <StyledDropdown
                              style={{
                                border: '1px solid rgb(166, 167, 176)',
                                padding: '11px 18px 11px 16px',
                                borderRadius: '8px',
                              }}
                            >
                              <Dropdown
                                fluid
                                placeholder=""
                                icon="chevron down"
                                name="accountType"
                                value={values.accountType}
                                text={accountType ? accountType.text : null}
                                errors={errors}
                                touched={touched}
                                handleFieldChange={handleFieldChange}
                                handleFieldBlur={handleFieldBlur}
                              >
                                <DropdownMenu>
                                  {VENDOR_BUSINESS_TYPE_OPTIONS.map(option => (
                                    <DropdownItem
                                      key={option.key}
                                      onClick={() =>
                                        handleBusinessDropdownChange(option)
                                      }
                                      selected={
                                        !!accountType &&
                                        option.value === accountType.value
                                      }
                                    >
                                      <Space gap={1} direction="column">
                                        <Text>{option.text}</Text>
                                        <Text
                                          variant="b12"
                                          color="bodyLight"
                                          style={{ whiteSpace: 'pre-wrap' }}
                                        >
                                          {option.description}
                                        </Text>
                                      </Space>
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </StyledDropdown>
                          </Conditional>
                        </Conditional>
                        <div className="select-with-custom-icon">
                          <Space
                            className="mb-1 mt-3"
                            gap={1}
                            alignItems="center"
                          >
                            <Text variant="b14" color="bodyLight">
                              Settlement Cycle
                            </Text>
                            <Conditional if={incrementalVendorOnboarding}>
                              <Popup
                                content={
                                  <Text variant="b12">
                                    <a
                                      href={VENDOR_SETTLEMENT_CYCLE_INFO_LINK}
                                      target="_blank"
                                    >
                                      Click here
                                    </a>{' '}
                                    to know more on the settlement cycles.
                                  </Text>
                                }
                                trigger={
                                  <div className="pointer">
                                    <CustomIcon componentName="INFO" />
                                  </div>
                                }
                                position="top center"
                                hoverable
                              />
                            </Conditional>
                          </Space>
                          <StyledDropdown>
                            <Dropdown
                              fluid
                              name="scheduleOption"
                              label="Vendor Settlement Cycle"
                              value={values.scheduleOption}
                              placeholder="Select Vendor Settlement Cycle"
                              options={SettlementCycleOptions}
                              errors={errors}
                              touched={touched}
                              onBlur={handleFieldBlur}
                              onChange={handleFieldChange}
                              disabled={disableField}
                              selection
                              icon="chevron down"
                            />
                          </StyledDropdown>
                        </div>
                        <Conditional if={showVendorDbToggle}>
                          <Space justifyContent="space-between">
                            <Space
                              direction="column"
                              className="dashboard-access"
                              gap={1}
                            >
                              <Space gap={1} alignItems="center">
                                <Text variant="h16" strong>
                                  Enable Dashboard Access
                                </Text>
                                <Conditional if={incrementalVendorOnboarding}>
                                  <Popup
                                    content={
                                      <Text variant="b12">
                                        <a
                                          href={VENDOR_DASHBOARD_INFO_LINK}
                                          target="_blank"
                                        >
                                          Click here
                                        </a>{' '}
                                        to know more about dashboard access.
                                      </Text>
                                    }
                                    trigger={
                                      <div className="pointer">
                                        <CustomIcon componentName="INFO" />
                                      </div>
                                    }
                                    position="top center"
                                    hoverable
                                  />
                                </Conditional>
                              </Space>
                              <Text variant="b12" color="bodyLight">
                                You can allow your vendors to access Vendor
                                Dashboard and view their transaction details.
                              </Text>
                            </Space>
                            <div>
                              <Toggle
                                active={active}
                                onToggle={onToggle}
                                className="ml-2"
                              />
                            </div>
                          </Space>
                        </Conditional>
                      </>
                    )}

                    <Conditional if={step === 2}>
                      <div
                        className="navigate-back"
                        onClick={() => setStep(step - 1)}
                        data-event-name="Form_VendorDetailsForm_Step2_Back"
                        data-ignore-inner-text="true"
                      >
                        <CustomIcon
                          componentName="CHEVRONDOWN"
                          direction="up"
                        />
                        <span>Back</span>
                      </div>
                      <Space justifyContent="space-between">
                        <Text variant="h16" strong className="mb-2">
                          Vendor Bank Account Details
                        </Text>
                        <span className="step">
                          Step {step}/{isKycDataFilled ? 3 : 2}
                        </span>
                      </Space>
                      <Text variant="b14" color="bodyLight" className="mb-4">
                        Provide bank account details or UPI VPA of the vendor.
                        Ensure you provide the correct bank account details for
                        successful settlements to vendor accounts.
                      </Text>
                      <div>
                        <InputField
                          fluid
                          id="name"
                          name="name"
                          label="Account Holder Name"
                          value={values.name}
                          errors={errors}
                          touched={touched}
                          onBlur={handleFieldBlur}
                          onChange={(e, data) => {
                            const pattern = /^[a-zA-Z0-9-/&.\s]*$/;
                            if (
                              !pattern.test(e.target.value) &&
                              e.target.value
                            ) {
                              return;
                            }
                            handleFieldChange(e, data);
                          }}
                          disabled={
                            disableField || vendorStatus === IN_BENE_CREATION
                          }
                        />
                      </div>
                      <div className="two-field-row mb-4 mt-3">
                        <InputField
                          fluid
                          id="accountNumber"
                          name="accountNumber"
                          label="Account Number"
                          value={values.accountNumber}
                          errors={errors}
                          touched={touched}
                          onBlur={handleFieldBlur}
                          className="first-feild"
                          onChange={(e, data) => {
                            const pattern = /^[a-zA-Z0-9]*$/;
                            if (
                              !pattern.test(e.target.value) &&
                              e.target.value
                            ) {
                              return;
                            }
                            handleFieldChange(e, data);
                          }}
                          disabled={
                            disableField || vendorStatus === IN_BENE_CREATION
                          }
                        />
                        <InputField
                          fluid
                          id="ifsc"
                          name="ifsc"
                          label="IFSC Code"
                          value={values.ifsc}
                          errors={errors}
                          touched={touched}
                          onBlur={handleFieldBlur}
                          className="second-field"
                          onChange={(e, data) => {
                            handleFieldChange(e, data);
                            const { value } = e.target;
                            if (value.toUpperCase().startsWith('PYTM')) {
                              setTimeout(() => {
                                formikProps.setFieldError(
                                  'ifsc',
                                  'PayTm bank account is not allowed as settlement account',
                                );
                              }, 0);
                            }
                          }}
                          disabled={
                            disableField || vendorStatus === IN_BENE_CREATION
                          }
                        />
                      </div>
                      <Conditional if={vpaEnabled}>
                        <Conditional if={vpaEnabled}>
                          <Text
                            variant="b14"
                            strong
                            className="mb-4 or"
                            color="bodyLight"
                          >
                            <span>Or</span>
                          </Text>
                          <InputField
                            fluid
                            id="vpa"
                            name="vpa"
                            label="UPI VPA"
                            value={values.vpa}
                            errors={errors}
                            touched={touched}
                            onBlur={handleFieldBlur}
                            onChange={handleFieldChange}
                            disabled={
                              disableField || vendorStatus === IN_BENE_CREATION
                            }
                          />
                        </Conditional>
                        <Conditional if={!vpaEnabled}>
                          <Text variant="b12" color="warning">
                            UPI account based settlements are not enabled,
                            please contact your account manager to get this
                            enabled.
                          </Text>
                        </Conditional>
                      </Conditional>
                      <Conditional if={!vpaEnabled}>
                        <Text variant="b12" color="warning">
                          UPI account based settlements are not enabled, please
                          contact your account manager to get this enabled.
                        </Text>
                      </Conditional>
                      {/* <Space gap={1} direction="column" className="mt-4">
                        <div className="form-input-wrapper input-checkbox">
                          <div>
                            <Checkbox
                              id="verifyAccount"
                              name="verifyAccount"
                              label="Verify Account Details"
                              checked={values.verifyAccount}
                              onChange={handleFieldChange}
                              onBlur={handleFieldBlur}
                              disabled={disableField}
                            />
                          </div>
                        </div>
                        {values.verifyAccount && (
                          <Text variant="b12" color="warning">
                            {verificationMessage}
                          </Text>
                        )}
                      </Space> */}
                    </Conditional>

                    <div className="cta-wrapper btn-class">
                      <Conditional if={!detailsPageClicked}>
                        <Button
                          link
                          type="button"
                          className="link"
                          onClick={onCancelHandler}
                          data-event-name="Form_VendorDetailsForm_Button_Cancel"
                          data-event-properties={JSON.stringify({ step })}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          primary
                          loading={disableField}
                          data-event-name="Primary_Button_Next"
                          data-event-properties={JSON.stringify({ step })}
                        >
                          Next
                        </Button>
                      </Conditional>
                      <Conditional if={detailsPageClicked}>
                        <Conditional
                          if={
                            step === 1 ||
                            (step === 2 && vendorDocs?.documents?.length)
                          }
                        >
                          <Button
                            link
                            type="button"
                            className="link"
                            onClick={() => onNextClickHandler(values)}
                            data-event-name="Form_VendorDetailsForm_Button_Next"
                            data-event-properties={JSON.stringify({ step })}
                          >
                            Next
                          </Button>
                        </Conditional>
                        <Button
                          type="submit"
                          primary
                          loading={disableField}
                          data-event-name="Primary_Button_Save"
                        >
                          Save
                        </Button>
                      </Conditional>
                    </div>
                  </form>
                );
              }}
            </FormikComponent>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
}

VendorDetailsForm.propTypes = {
  open: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  scheduleOptions: PropTypes.object.isRequired,
  editModalLoading: PropTypes.bool,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  handleVendorDetailsPayload: PropTypes.func,
  vendorFormData: PropTypes.object.isRequired,
  setVendorFormData: PropTypes.func.isRequired,
  vendorStatus: PropTypes.string.isRequired,
  vpaEnabled: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  isKycDataFilled: PropTypes.bool.isRequired,
  detailsPageClicked: PropTypes.bool.isRequired,
  passVendorDetails: PropTypes.func,
  incrementalVendorOnboarding: PropTypes.bool,
  submitVendorDetails: PropTypes.func,
  vendorCreated: PropTypes.bool,
  vendorDocs: PropTypes.object,
};

export default memo(VendorDetailsForm);
